import { Wizard } from '@/components/layout/Wizard';
import { Background, Container } from '@/components/wm';
import { apiRequest } from '@/utils/request';
import { getStoreResource } from '@/utils/store';
import React from 'react';
import { Schedule } from '../Schedule';
import { Properties } from './Content/Properties';
import { SelectAlarms } from './Content/SelectAlarms';

export default function BulkEditAlarms () {
    const initialData = {
        ids: [],
        indicatorKind: '',
        maxValue: null,
        minValue: null,
        name: '',
        schedule: {},
        type: '',
        userIds: []
    };

    const steps = [
        { Component: SelectAlarms, title: i18next.t('alarms.bulk_alarms'), description: i18next.t('alarms.bulk_alarms_description') },
        { Component: Properties, title: i18next.t('alarms.bulk_edit'), description: i18next.t('alarms.bulk_edit_description') },
        { Component: Schedule, title: i18next.t('modal.title.alarm_schedules.new') }
    ];

    const handleSubmit = async data => {
        const indicatorKind = getStoreResource('indicatorKinds', data.indicatorKind);
        const unit = getStoreResource('units', indicatorKind.unit_id)?.symbol;

        if (unit === 'Wh') {
            if (data.minValue !== null && data.minValue !== '') {
                data.minValue = data.minValue * 1000;
            }
            if (data.maxValue !== null && data.maxValue !== '') {
                data.maxValue = data.maxValue * 1000;
            }
        }

        let mapping = {
            ids: data.ids,
            max_value: data.maxValue,
            min_value: data.minValue,
            name: data.name,
            schedule: data.schedule,
            user_ids: data.userIds
        };

        const finalData = Object.entries(mapping).reduce((acc, [key, value]) => {
            // This check catches undefined, null, and empty strings,
            // but keeps '0' or 'false' (which are valid data)
            if (value !== undefined && value !== null && value !== '' && !(typeof value === 'object' && Object.keys(value).length === 0)) {
                acc[key] = value;
            }
            return acc;
        }, {});

        try {
            const response = await apiRequest('/alarms/bulk_update', 'PUT', finalData);

            WiseMetering.alarms.fetch();

            return response;
        } catch (err) {
            throw new Error(err); // Throwing it so Wizard can catch
        }
    };

    return (
        <Background>
            <Container>
                <Wizard
                    handleSubmit={handleSubmit}
                    initialData={initialData}
                    steps={steps}
                />
            </Container>
        </Background>
    );
}
